<template>
<div></div>
</template>

<script>
export default {
	name: 'settingsCallback',
	created() {
		const urlString = window.location.href;
		const url = new URL(urlString);
		const code = url.searchParams.get('code');
		const type = this.$route.params.type;
		const name = this.$route.params.name;
		const redirectUrl = `/settings/${type}/?name=${name}&code=${code}`;
		this.$router.push(redirectUrl);
	},
};
</script>
